import { componentStyles } from "./side-by-side-tabs-and-process-tabs-desktop-component.scss";
import SideBySideTabsAndProcessTabs from "../side-by-side-tabs-and-process-tabs";

const SideBySideTabsAndProcessTabsDesktopComponent = (props) => (
  <div className="side-by-side-tabs-and-process-tabs-desktop-component">
    <SideBySideTabsAndProcessTabs {...props} />
    <style jsx>{componentStyles}</style>
  </div>
);

export default SideBySideTabsAndProcessTabsDesktopComponent;
